/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import EasingValue = alm.math.EasingValue;
	import KeyCode = alm.browser.KeyCode;
	import Num = alm.util.Num;
	import Cmd = alm.util.Cmd;
	import EasingFunction = alm.math.EasingFunction;
	import Easing = alm.math.Easing;

	export class OrbitBehavior implements ICameraBehavior {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(camera:THREE.PerspectiveCamera) {
			this.camera = camera;

			this.position = new EasingVector3(new THREE.Vector3(), 0.1);
			this.lookAt = new EasingVector3(new THREE.Vector3(), 0.1);
			this.angle = new EasingValue(0, 0.1);
			this.distance = new EasingValue(0, 0.1);
			this.offsetHeight = new EasingValue(0, 0.1);
			this.orbitCenter = new THREE.Vector3(0, 3000, 0);

			this.isMouseDown = false;
			this.isMouseDragged = false;
			this.mouseDownX = 0;
			this.mouseDownY = 0;
			this.mouseDragX = 0;
			this.mouseDragY = 0;
			this.mouseX = 0;
			this.mouseY = 0;
			this.mouseDownXRatio = 0;
			this.mouseDownYRatio = 0;
			this.mouseDragXRatio = 0;
			this.mouseDragYRatio = 0;
			this.mouseXRatio = 0;
			this.mouseYRatio = 0;

			this.motionStartAttitude = new OrbitCameraAttitude();
			this.motionEndAttitude = new OrbitCameraAttitude();
			this.isAnimating = false;

			this.stop();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public start():void {
			trace('[OrbitBehavior] start');
		}

		public stop():void {
			trace('[OrbitBehavior] stop');
			this.stopAnimation();
		}





		public reset(center:THREE.Vector3):void {
			this.stopAnimation();

			this.orbitCenter.set(center.x, center.y, center.z);

			this.angle.target = 0;
			this.angle.update(false);

			this.distance.target = 500;
			this.distance.update(false);

			this.offsetHeight.target = 200;
			this.offsetHeight.update(false);

			this.updateAttitude(false);
		}

		public update(center:THREE.Vector3, useTransition:boolean = true):void {
			if (this.isAnimating) {
				useTransition = false;
			} else {
				if (this.isMouseDragged) {
					this.angle.target += this.mouseDragXRatio * 0.02;

					this.offsetHeight.target += this.mouseDragYRatio * 20;
					this.offsetHeight.target = Num.clamp(this.offsetHeight.target, 0, 2600);
					//trace('[CameraManager] targetHeight : ', this.offsetHeight.target);
				}
			}

			this.orbitCenter.set(center.x, center.y, center.z);
			this.angle.update(useTransition);
			this.distance.update(useTransition);
			this.offsetHeight.update(useTransition);

			this.updateAttitude(useTransition);
		}

		private updateAttitude(useTransition:boolean = true):void {
			this.lookAt.setTarget(this.orbitCenter.x, this.orbitCenter.y, this.orbitCenter.z);
			this.lookAt.update(useTransition);

			this.position.setTarget(
				this.orbitCenter.x + this.distance.value * Math.cos(this.angle.value),
				this.orbitCenter.y + this.offsetHeight.value,
				this.orbitCenter.z + this.distance.value * Math.sin(this.angle.value)
			);
			this.position.update(useTransition);

			this.camera.position.set(this.position.x.value, this.position.y.value, this.position.z.value);
			this.camera.lookAt(this.lookAt.x.value, this.lookAt.y.value, this.lookAt.z.value);
		}

		public resize(stageWidth:number, stageHeight:number):void {
			this.stageWidth = stageWidth;
			this.stageHeight = stageHeight;
		}





		public onKeyDown(keyCode:number, shiftKey:boolean):void {
			switch (keyCode) {
				case KeyCode.UpArrow:
					this.offsetHeight.target += shiftKey ? 4 : 2;
					break;
				case KeyCode.DownArrow:
					this.offsetHeight.target -= shiftKey ? 4 : 2;
					break;

				case KeyCode.F:
					this.distance.target -= shiftKey ? 4 : 2;
					this.distance.target = Num.clamp(this.distance.target, 100, 2500);
					break;
				case KeyCode.B:
					this.distance.target += shiftKey ? 4 : 2;
					this.distance.target = Num.clamp(this.distance.target, 100, 2500);
					break;

				case KeyCode.LeftArrow:
					this.angle.target += shiftKey ? 0.01 : 0.005;
					break;
				case KeyCode.RightArrow:
					this.angle.target -= shiftKey ? 0.01 : 0.005;
					break;
			}
		};

		public onKeyUp(keyCode:number, shiftKey:boolean):void {
			switch (keyCode) {
				case KeyCode.R:
					this.reset(this.orbitCenter);
					break;
			}
		}

		public onMouseDown(mouseX:number, mouseY:number, button:number):void {
			this.isMouseDown = true;

			this.mouseDownX = mouseX;
			this.mouseDownY = mouseY;
			this.mouseDownXRatio = Num.map(this.mouseDownX, 0, this.stageWidth, -1, 1);
			this.mouseDownYRatio = Num.map(this.mouseDownY, 0, this.stageHeight, -1, 1);
		};

		public onMouseUp(mouseX:number, mouseY:number, button:number):void {
			this.isMouseDown = false;
			this.isMouseDragged = false;

			this.mouseDragX = 0;
			this.mouseDragY = 0;
			this.mouseDragXRatio = 0;
			this.mouseDragYRatio = 0;
		};

		public onMouseMove(mouseX:number, mouseY:number, button:number):void {
			this.mouseX = mouseX;
			this.mouseY = mouseY;
			this.mouseXRatio = Num.map(this.mouseX, 0, this.stageWidth, -1, 1);
			this.mouseYRatio = Num.map(this.mouseY, 0, this.stageHeight, -1, 1);

			if (this.isMouseDown) {
				this.isMouseDragged = true;

				this.mouseDragX = this.mouseX - this.mouseDownX;
				this.mouseDragY = this.mouseY - this.mouseDownY;
				this.mouseDragXRatio = this.mouseXRatio - this.mouseDownXRatio;
				this.mouseDragYRatio = this.mouseYRatio - this.mouseDownYRatio;
			}
		};

		public onMouseWheel(delta:number):void {
			if (!this.isAnimating) {
				this.distance.target += Num.map(delta, -10, 10, -1, 1) * 30;
				this.distance.target = Num.clamp(this.distance.target, 100, 2500);
			}
		};





		public recordAttitudeAsStart():void {
			this.recordAttitude(this.motionStartAttitude);
		}

		public recordAttitudeAsEnd():void {
			this.recordAttitude(this.motionEndAttitude);
		}

		private recordAttitude(attitude:OrbitCameraAttitude):void {
			trace('[CameraManager] record attitude : distance =', this.distance.value, ', angle =', this.angle.value, ', height =', this.offsetHeight.value);
			attitude.set(this.distance.value, this.angle.value, this.offsetHeight.value);
		}

		public playAnimation(duration:number, easing:EasingFunction):void {
			this.stopAnimation();

			const startDistance:number = this.motionStartAttitude.getDistance();
			const startAngle:number = this.motionStartAttitude.getAngle();
			const startHeight:number = this.motionStartAttitude.getHeight();

			const endDistance:number = this.motionEndAttitude.getDistance();
			const endAngle:number = this.motionEndAttitude.getAngle();
			const endHeight:number = this.motionEndAttitude.getHeight();

			this.motionTween = new cmd.Serial(
				new cmd.Func(():void => {
					trace('[OrbitBehavior] animation start');
					this.isAnimating = true;
				}),
				new cmd.Parallel(
					new cmd.Tween(this.distance, { target: endDistance }, { target: startDistance }, duration, easing),
					new cmd.Tween(this.angle, { target: endAngle }, { target: startAngle }, duration, easing),
					new cmd.Tween(this.offsetHeight, { target: endHeight }, { target: startHeight }, duration, easing)
				),
				new cmd.Func(():void => {
					trace('[OrbitBehavior] animation end');
					this.isAnimating = false;
				})
			);
			this.motionTween.execute();
		}

		public stopAnimation():void {
			if (!this.isAnimating) return;
			this.isAnimating = false;

			this.motionTween = Cmd.stop(this.motionTween);
		}

		public animateCamera(from:object, to:object, duration:number):void {
			this.motionStartAttitude.set(from['distance'], from['angle'], from['height']);
			this.motionEndAttitude.set(to['distance'], to['angle'], to['height']);
			this.playAnimation(duration, Easing.easeInOutQuad);
		}

		public getAttitudeString():string {
			return JSON.stringify({ distance: this.distance.value, angle: this.angle.value, height: this.offsetHeight.value });
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private camera:THREE.PerspectiveCamera;

		private orbitCenter:THREE.Vector3;
		private angle:EasingValue;
		private distance:EasingValue;
		private offsetHeight:EasingValue;
		private position:EasingVector3;
		private lookAt:EasingVector3;

		private isMouseDown:boolean;
		private isMouseDragged:boolean;
		private mouseDownX:number;
		private mouseDownY:number;
		private mouseDownXRatio:number;
		private mouseDownYRatio:number;
		private mouseDragX:number;
		private mouseDragY:number;
		private mouseDragXRatio:number;
		private mouseDragYRatio:number;
		private mouseX:number;
		private mouseY:number;
		private mouseXRatio:number;
		private mouseYRatio:number;
		private stageWidth:number;
		private stageHeight:number;

		private motionStartAttitude:OrbitCameraAttitude;
		private motionEndAttitude:OrbitCameraAttitude;
		private isAnimating:boolean;
		private motionTween:cmd.Serial;
	}
}
